// extracted by mini-css-extract-plugin
module.exports = {"Heading":"AddCardModal_Heading__1rsEu"};